import {StaticDataService} from '../../../services/static-data.service';

export class TreatmentUtils {
  private staticDataService: StaticDataService;

  constructor(staticDataService: StaticDataService) {
    this.staticDataService = staticDataService;
  }

  checkBool(prop: boolean, name: string, isNoLinebreak: boolean = false) {
    let lb = '\r\n';
    if (isNoLinebreak) {
      lb = '';
    }
    if (prop != null && prop) {
      return name + lb;
    } else {
      return '';
    }
  }

  checkEnum(id: string, name: string, isNoLinebreak: boolean = false) {
    if (id === null) {
      return '';
    }

    let lb = '\r\n';
    if (isNoLinebreak) {
      lb = '';
    }
    const enu = this.staticDataService.getValidValueItemsByItemIds([id]);
    if (enu && enu[0] !== undefined) {
      return name + enu[0].ItemDisplayValue + lb;
    } else {
      return '';
    }
  }
  checkNull(val : string)
  {

    var r : string ='';

    if(val===null ||  val===undefined) { r = '';}
    else {r = val;}

    return r;
  }


}
